export interface BillingEstimateStatus {
  billingStatus?: "ready" | "validation_pending";
  ownership?: { status: "verified" | "held"; includedDeals: number; excludedDeals: number; unverifiedDeals: number; reasons: string[] };
}

export const isBillingValidationPending = (estimate: BillingEstimateStatus) =>
  estimate.billingStatus !== "ready" || estimate.ownership?.status !== "verified";

interface ChargeAmount {
  status?: "ready" | "verified_zero" | "not_due" | "validation_pending";
  estimatedAmount: number;
  currency: string;
  billing: { extrapolatedAmount: number };
  estimate: BillingEstimateStatus;
}

/** Pending amounts are unknown; zero placeholders never contribute to a verified total. */
export function summarizeUpcomingChargeAmounts(charges: readonly ChargeAmount[], currency: string) {
  let verifiedEstimatedAmount = 0;
  let verifiedExtrapolatedAmount = 0;
  let verifiedCount = 0;
  let pendingCount = 0;
  for (const charge of charges) {
    // Explicit no-charge policy proves the amount, not trade ownership or profit.
    if (charge.status === "not_due" && charge.estimate.billingStatus !== "validation_pending" && charge.estimate.ownership?.status !== "held" && charge.estimatedAmount === 0 && charge.billing.extrapolatedAmount === 0) continue;
    if (isBillingValidationPending(charge.estimate) || charge.currency !== currency ||
      !Number.isFinite(charge.estimatedAmount) || !Number.isFinite(charge.billing.extrapolatedAmount)) {
      pendingCount++;
      continue;
    }
    verifiedCount++;
    verifiedEstimatedAmount += charge.estimatedAmount;
    verifiedExtrapolatedAmount += charge.billing.extrapolatedAmount;
  }
  return {
    verifiedEstimatedAmount: Math.round(verifiedEstimatedAmount * 100) / 100,
    verifiedExtrapolatedAmount: Math.round(verifiedExtrapolatedAmount * 100) / 100,
    verifiedCount,
    pendingCount,
    isComplete: pendingCount === 0,
  };
}
